import RatePlanStatusEnum from '@constants/enums/ratePlan/status';
import RatePlanTypeEnum from '@constants/enums/ratePlan/type';

import i18n from '@plugins/i18n';

import Collection from '@/models/Collection';
import RatePlan from '@/models/RatePlan';

export class RatePlanCollection extends Collection {
    static type = 'RatePlanCollection';
    static endpoint = RatePlan.api.index;
    static model = RatePlan;

    get default_headers() {
        return ['name', 'type', 'status', 'default'];
    }

    get preset_sort_by() {
        return ['name:asc'];
    }

    get headers() {
        return [
            this.createHeader('name', i18n.t('name'), {
                filterable: true,
                width: '18rem'
            }),
            this.createHeader('type', i18n.t('_page.rate_plan.type'), {
                format: 'enum',
                filterable: true,
                enum: RatePlanTypeEnum,
                enumA11yKey: 'enums.rate_plan_type',
                width: '12rem'
            }),
            this.createHeader('status', i18n.t('status'), {
                format: 'enum',
                filterable: true,
                enum: RatePlanStatusEnum,
                enumA11yKey: 'enums.rate_plan_status',
                width: '12rem'
            }),
            this.createHeader('default', i18n.t('_page.rate_plan.default'), {
                format: 'boolean',
                width: '8rem'
            })
        ];
    }

    /**
     * Selector helper: only ACTIVE plans for the given adviser and optional type.
     * @param {string} adviserId
     * @param {string|null} type
     * @param {string|null} excludeId
     * @returns {object}
     */
    static selectorFilters(adviserId = null, type = null, excludeId = null) {
        const filters = {
            status: `eq:${RatePlanStatusEnum.ACTIVE}`
        };

        if (adviserId) {
            filters.adviser_id = `eq:${adviserId}`;
        }

        if (type) {
            filters.type = `eq:${type}`;
        }

        if (excludeId) {
            filters.id = `neq:${excludeId}`;
        }

        return filters;
    }

    /**
     * Find the default plan for an adviser and type from loaded items.
     * @param {Array<RatePlan>} items
     * @param {string} type
     * @returns {RatePlan|null}
     */
    static findDefaultPlan(items = [], type) {
        return (
            items.find(item => item?.default && item.type === type) ||
            items.find(item => item?.type === type && item.is_default) ||
            null
        );
    }
}

export default RatePlanCollection;
